module.exports = __webpack_public_path__ + "img/alert-icon-warning.aa7aea3d.svg";